import React from 'react'
import './AddClinic.scss'
import clinicImg from './clinic_icon.svg'

const AddClinic = ({ lexicon }) => (
  <div className="AddClinic">
    <img src={clinicImg} alt="clinic" />
    <h2>{lexicon.get('title')}</h2>

    <a
      href="https://airtable.com/appQSrPLh0HjdYHre/pagLKhhsFQ6sds3vv/form"
      target="_blank"
      rel="noopener noreferrer"
    >
      {lexicon.get('button')}
    </a>
  </div>
)

export default AddClinic
